<template>
    <el-card
    :shadow="shadow"
    class="box-card">
        <!-- <div slot="header" class="clearfix">
            <span>卡片名称</span>
            <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>
        </div> -->
        <div>
            <slot name="cardbody"></slot>
        </div>
    </el-card>
</template>
<script>
import {
    Card
} from 'element-ui'
export default {
    name:'cardBox',
    props:{
        shadow:{
            type:String,
            default:'never'
        }
    },
    data(){
        return {

        }
    },
    components:{
        elCard:Card
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/cardBox.vue